import type { CoverSheetConfigCard } from '../../types';

export const salesPriceCard = {
  id: 'propertyInfo.salesPrice',
  innerTitle: 'Sales Price',
  fields: {
    salesPrice: {
      name: 'salesPrice',
      entity: 'interaction',
      type: 'money',
      label: 'Current Sales Price',
      placeholderText: '0.00',
    },
  },
} satisfies CoverSheetConfigCard;
